/**
 * Extrait un message d'erreur lisible depuis une erreur de récupération SERP.
 *
 * Sur une réponse non-2xx, `RTK Query.unwrap()` rejette avec un objet
 * `{ status, data }` (et non une instance d'Error) — c'est pourquoi le test
 * `err instanceof Error` retombait sur "Erreur inconnue". On lit ici le message
 * renvoyé par le backend (`data.error`) avant de retomber sur les autres formes.
 */
export default function getSerpErrorMessage(err: unknown): string {
    if (err && typeof err === 'object') {
        const { data, error } = err as { data?: unknown; error?: unknown };

        // Erreur HTTP RTK Query : { status, data: { error } }
        if (data && typeof data === 'object') {
            const backendError = (data as { error?: unknown }).error;
            if (typeof backendError === 'string' && backendError) return backendError;
        }

        // Erreur réseau RTK Query : { status: 'FETCH_ERROR', error }
        if (typeof error === 'string' && error) return error;

        // Error classique levée manuellement
        if (err instanceof Error && err.message) return err.message;
    }

    return 'Erreur inconnue';
}
